import React from "react";
import "./about.css";

const aboutUs = () => {
  const siteName = window.location.hostname.replace("www.", "").split(".")[0];
const fullDomain = window.location.hostname; 
const domain = fullDomain.replace(/^www\./, "");
  return (
    <>
      <div className="contain_center mt-3">
        <p className="inner_contain">
          <center>
            <h3 style={{ fontWeight: 600, fontSize: "22px" }}>About Us</h3>
          </center>
          <p>
            Welcome to {domain}, an Indian e-commerce platform
            owned and operated by {process.env.REACT_APP_FAM}. {siteName} is
            committed to offering quality products with transparent pricing and
            clear customer policies. We operate this website independently and
            are fully responsible for all products, services, payments,
            deliveries, and customer support provided through this platform.
          </p>
          <center>
            <h3 style={{ fontWeight: 600, fontSize: "22px" }}>Who We Are</h3>
          </center>
          <p>
            {process.env.REACT_APP_FAM} is a trusted name in the industry, known
            for our commitment to delivering exceptional value and top-notch
            products. With years of experience and a passion for excellence, we
            strive to exceed our customers' expectations in every way possible.
          </p>
          <h3 style={{ fontWeight: 600, fontSize: "22px" }}>Our Mission</h3>
          <p>
            Our goal is to ensure a trustworthy and straightforward shopping
            experience by clearly communicating product details, pricing,
            shipping timelines, and return or refund processes so customers can
            make informed purchasing decisions.
          </p>
          {/* <h3 style={{ fontWeight: 600, fontSize: "22px" }}>
            What We Offer At
          </h3>
          <p>
            {window.location.hostname}, you will find a wide range of products
            meticulously crafted to meet the highest standards of quality. Our
            extensive product line is designed to cater to diverse needs and
            preferences, ensuring that there is something for everyone.
          </p> */}
          <h3 style={{ fontWeight: 600, fontSize: "22px" }}>Why Choose Us</h3>
          <ul className="list-disc list-inside mb-4">
            <li>Transparent pricing and policies</li>
            <li>Clear shipping, return, and refund processes</li>
            <li>Dedicated customer support</li>
            <li>Commitment to customer satisfaction</li>
          </ul>
        </p>
        <div style={{ textAlign: "start" }}>
          <h3 style={{ fontWeight: 600, fontSize: "22px" }}>
            Business Information
          </h3>
          <p>
            Business Owner: {process.env.REACT_APP_FAM} <br />
            Website: {domain} <br />
            Email: support@{domain} <br />
            phone: +91-{process.env.REACT_APP_MO} <br />
            Registered Address: {process.env.REACT_APP_ADDRESS} <br />
          </p>
          <p>
            FSSAI Registrations/Lincense No. : 20725022003841
            </p>
          <p>Business Hours: Monday to Saturday, 10:00 AM – 6:00 PM IST</p>
          <p>
            We are committed to complying with all applicable laws and
            advertising policies and continuously improving our platform to
            maintain transparency, customer trust, and satisfaction.
          </p>
        </div>
      </div>
    </>
  );
};

export default aboutUs;
